import { Serializable } from './Serializable';

export class CategoryDTO extends Serializable {
    id: string;
    name: string;
    
    constructor() {
        super();
    }
    
}
